import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';

const Addg = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: 0;
  cursor: pointer;
  :hover {
    color: var(--text-secondary);
  }
`;
const Status = styled.div`
  max-width: 453px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  border-top: 0.5px solid var(--border-primary);
  padding-top: 12px;
  [data-rbd-droppable-context-id] {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

const Statusrow1 = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 10px;
  justify-content: space-between;
  .plus-icon {
    stroke: var(--text-secondary);
  }
  ${mobile_xl(css`
    padding: 6px 5px;
  `)}
`;
const Statusrows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 10px;
  justify-content: space-between;
  gap: 10px;
  ${mobile_xl(css`
    padding: 6px 8px;
  `)}
`;
const Line = styled.div`
  width: 100%;
  position: relative;
  :hover {
    background-color: var(--neutral-secondary);
    border-radius: 30px;
  }
  :hover .svgicon {
    opacity: 1;
  }
  ${mobile_xl(css`
    :hover {
      background-color: unset;
      border-radius: 0;
    }
  `)}
`;
const Iconhidden = styled.div`
  position: absolute;
  left: -18px;
  top: 7px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  .svgicon {
    opacity: 0;
    stroke: var(--text-secondary);
  }
`;

const DropDiv = styled.div`
  .active-state {
    border-radius: 4px;
    background-color: var(--background-muted);
  }
`;
export { Addg, Status, Statusrows, Iconhidden, Line, Statusrow1, DropDiv };
